export default __webpack_public_path__ + "static/media/rewarded.911e5dac.svg";